import { MODO_DEMO, UNIDAD_DEMO } from './demo'

/**
 * Unidades en las que la Agenda de Quirófano está habilitada en producción.
 * En ambiente demo (utils/demo.js) solo la unidad de Integración Procesos Clínicos.
 * Se identifican por el Building_Id del catálogo de buildings.
 */
const UNIDADES_PRODUCCION = [
    'Hospital-MAC-Mexicali',
    'Hospital-MAC-Santa Fe',
    'Hospital-MAC-Perisur',
    'Hospital-MAC-Guadalajara',
    'Hospital-MAC-Ecatepec',
    'Hospital-MAC-Interlomas',
    'Hospital-MAC-La Viga',
    'Hospital-MAC-León',
    'Hospital-MAC-Tijuana',
    'Hospital-HMAS-Los Cabos',
    'Hospital-MAC-Celaya',
    'Hospital-MAC-Tampico',
    'Hospital-MAC-Integración Procesos Clínicos',
]

export const UNIDADES_HABILITADAS = MODO_DEMO ? [UNIDAD_DEMO] : UNIDADES_PRODUCCION

/** Unidades con acceso al login aunque no sean un building (p. ej. Corporativo). */
export const UNIDADES_ESPECIALES_LOGIN = ['Corporativo']

// Producción salvo que REACT_APP_ENV indique explícitamente "test" o "development"
// (si la variable no llega al build, se asume producción, igual que en la reservación pública).
const AMBIENTE = (process.env.REACT_APP_ENV || 'production').toLowerCase().trim()
export const IS_PRODUCTION = AMBIENTE !== 'test' && AMBIENTE !== 'development'

// En ambiente demo el catálogo de unidades se toma del servicio de pruebas
export const URL_BUILDING = (IS_PRODUCTION && !MODO_DEMO)
    ? 'https://agendaqx-getbuildingprod-1082492640140.us-south1.run.app'
    : 'https://agendaqx-getbuildingtest-1082492640140.us-south1.run.app'

/** Normaliza texto para comparar sin acentos, mayúsculas ni espacios extra. */
const normalizar = (txt) =>
    (txt || '')
        .toString()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[\s-]+/g, ' ')
        .trim()
        .toLowerCase()

const BUILDINGS_NORMALIZADOS = new Set(UNIDADES_HABILITADAS.map(normalizar))

/** Nombre "corto" derivado del Building_Id: 'Hospital-MAC-León' -> 'MAC León'. */
const nombreDesdeBuildingId = (buildingId) =>
    buildingId.replace(/^Hospital-/, '').replace(/-/g, ' ')

const NOMBRES_NORMALIZADOS = new Set([
    ...UNIDADES_HABILITADAS.map((b) => normalizar(nombreDesdeBuildingId(b))),
    ...UNIDADES_ESPECIALES_LOGIN.map(normalizar),
])

/** ¿El Building_Id está habilitado? */
export const esBuildingHabilitado = (buildingId) =>
    BUILDINGS_NORMALIZADOS.has(normalizar(buildingId))

/**
 * ¿La unidad del usuario (UnidadHospitalaria.hospital) puede entrar a la agenda?
 * 1. Corporativo siempre pasa.
 * 2. Se busca la unidad en el catálogo de buildings por HOSPITAL y se valida su Building_Id.
 * 3. Si no hay coincidencia en el catálogo, se compara contra el nombre derivado del Building_Id
 *    (ej. 'MAC Mexicali', 'HMAS Los Cabos').
 * @param {String} nomHospital Nombre de la unidad del usuario
 * @param {Array} buildingList Catálogo de buildings (puede venir vacío)
 */
export const esUnidadHabilitada = (nomHospital, buildingList = []) => {
    const nombre = normalizar(nomHospital)
    if (!nombre) return false
    if (UNIDADES_ESPECIALES_LOGIN.map(normalizar).includes(nombre)) return true

    const building = (buildingList || []).find(
        (b) => normalizar(b.HOSPITAL) === nombre || normalizar(b.Building_Id) === nombre
    )
    if (building && esBuildingHabilitado(building.Building_Id)) return true

    return NOMBRES_NORMALIZADOS.has(nombre)
}
